import { useRef, useState, useEffect } from 'react';
import { useMemoizedFn } from 'ahooks';
import { calcMax } from '@gp/pages/StudioDashboard/StudioOverall/components/LogoList/utils';

export default function useLogoLostCalc(initialMax?: number) {
  const containerNode = useRef<HTMLDivElement>(null);
  const listNode = useRef<HTMLUListElement>(null);
  // const moreBtnNode = useRef<HTMLButtonElement>(null);
  const [max, setMax] = useState(Number.isNaN(initialMax) ? 0 : initialMax);

  const handleResize = useMemoizedFn(() => {
    const newMax = calcMax(containerNode.current, /* moreBtnNode.current */34, 34, 10);
    setMax(newMax);
  });

  useEffect(() => {
    handleResize();
  }, []);

  useEffect(() => {
    window.addEventListener('resize', handleResize, false);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [handleResize]);

  return {
    containerNode,
    listNode,
    // moreBtnNode,
    max,
  };
}
